import { gql } from "@grandvisionhq/graphql";
const recreateOrderedCheckoutFailure = gql`
  fragment RecreateOrderedCheckoutFailureFragment on RecreateOrderedCheckoutFailure {
    code
    message
  }
`;
export {
  recreateOrderedCheckoutFailure
};
//# sourceMappingURL=recreate-ordered-checkout-failure.js.map
